export enum TransactionStatusPrimaryColorEnum {
  Pending = '#FB932A',
  Posted = '#78AB00',
  Reversed = '#78AB00',
  Adjusted = '#78AB00'
}

export enum TransactionStatusSecondaryColorEnum {
  Pending = '#FFEAD1',
  Posted = '#E8F7D9',
  Reversed = '#E8F7D9',
  Adjusted = '#E8F7D9'
}

export enum TransactionStatusTextColorEnum {
  Pending = '#B24819',
  Posted = '#395200',
  Reversed = '#395200',
  Adjusted = '#395200'
}

/* eslint-disable @typescript-eslint/naming-convention */
export const TransactionStatusPrimaryColorMap: Record<number, string> = {
  1: TransactionStatusPrimaryColorEnum.Pending,
  2: TransactionStatusPrimaryColorEnum.Posted,
  3: TransactionStatusPrimaryColorEnum.Reversed,
  4: TransactionStatusPrimaryColorEnum.Adjusted
};

export const TransactionStatusSecondaryColorMap: Record<number, string> = {
  1: TransactionStatusSecondaryColorEnum.Pending,
  2: TransactionStatusSecondaryColorEnum.Posted,
  3: TransactionStatusSecondaryColorEnum.Reversed,
  4: TransactionStatusSecondaryColorEnum.Adjusted
};

export const TransactionStatusTextColorMap: Record<number, string> = {
  1: TransactionStatusTextColorEnum.Pending,
  2: TransactionStatusTextColorEnum.Posted,
  3: TransactionStatusTextColorEnum.Reversed,
  4: TransactionStatusTextColorEnum.Adjusted
};
/* eslint-enable @typescript-eslint/naming-convention */
